import { CloningStepsEnum, CloningStepsModals } from '../constants'

export const reducerName = 'CLONING_STEPS'

const ActionTypes = {
  SET_CLONING_STEP: 'SET_CLONING_STEP',
  SET_MODAL: 'SET_MODAL',
  SET_OUTDATED_LEAGUES: 'SET_OUTDATED_LEAGUES',
  SET_PENDING_REMOVAL: 'SET_PENDING_REMOVAL',
  SET_SESSION_STARTING: 'SET_SESSION_STARTING',
}

const initialState = {
  step: CloningStepsEnum.BROWSE,
  modal: null,
  outdatedLeagues: [],
  pendingRemoval: null,
  // True from the moment the start request is dispatched until either the redirect
  // takes over (success) or a failure response comes back. Locks the footer.
  sessionStarting: false,
}

const CloningStepsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_CLONING_STEP:
      return {
        ...state,
        step: action.step,
      }

    case ActionTypes.SET_MODAL:
      return {
        ...state,
        modal: action.modal,
      }

    case ActionTypes.SET_OUTDATED_LEAGUES:
      return {
        ...state,
        outdatedLeagues: action.outdatedLeagues,
      }

    case ActionTypes.SET_PENDING_REMOVAL:
      return {
        ...state,
        pendingRemoval: action.pendingRemoval,
      }

    case ActionTypes.SET_SESSION_STARTING:
      return {
        ...state,
        sessionStarting: action.sessionStarting,
      }

    default:
      return { ...state }
  }
}

const setCloningStepAction = (cloningStep) => ({
  type: ActionTypes.SET_CLONING_STEP,
  step: cloningStep,
})

export const setCloningStep = (cloningStep) => (dispatch) => {
  dispatch(setCloningStepAction(cloningStep))
}

const setCloningModalAction = (cloningModal) => ({
  type: ActionTypes.SET_MODAL,
  modal: cloningModal,
})

export const setCloningModal = (cloningModal) => (dispatch) => {
  dispatch(setCloningModalAction(cloningModal))
}

const setOutdatedLeaguesAction = (outdatedLeagues) => ({
  type: ActionTypes.SET_OUTDATED_LEAGUES,
  outdatedLeagues,
})

export const applyOutdatedLeaguesResponse = ({ outdatedLeagues, cloneLeaguesSession }) => (dispatch) => {
  dispatch(setCloningStepAction(cloneLeaguesSession?.data?.cloningStep || CloningStepsEnum.BROWSE))
  dispatch(setOutdatedLeaguesAction(outdatedLeagues))
  dispatch(setCloningModalAction(CloningStepsModals.OUTDATED_LEAGUES))
}

export const setSessionStarting = (sessionStarting) => (dispatch) => {
  dispatch({ type: ActionTypes.SET_SESSION_STARTING, sessionStarting })
}

export const setPendingRemoval = (leagueId, dateKey) => (dispatch) => {
  dispatch({ type: ActionTypes.SET_PENDING_REMOVAL, pendingRemoval: leagueId ? { leagueId, dateKey } : null })
}

export const selectCloningStep = state => state?.[reducerName]?.step
export const selectCloningModal = state => state?.[reducerName]?.modal
export const selectOutdatedLeagues = state => state?.[reducerName]?.outdatedLeagues ?? []
export const selectPendingRemoval = state => state?.[reducerName]?.pendingRemoval
export const selectSessionStarting = state => !!state?.[reducerName]?.sessionStarting

export const namedReducer = { [reducerName]: CloningStepsReducer }

export const getInitialState = (cloneLeaguesSession, { outdatedLeagues = [] } = {}) => {
  const providedStep = cloneLeaguesSession?.data?.cloningStep
  return {
    step: providedStep || CloningStepsEnum.BROWSE,
    outdatedLeagues,
    modal: outdatedLeagues.length > 0 ? CloningStepsModals.OUTDATED_LEAGUES : null,
    pendingRemoval: null,
    sessionStarting: false,
  }
}
export default CloningStepsReducer
